import type { AppLoadContext } from '@remix-run/cloudflare';
import type { Output, ValiError } from 'valibot';
import { enum_, nonOptional, object, optional, parse, string, transform, unknown } from 'valibot';
import { dbConfig, envURL, stripeKeyEnv } from './createSbClientSSR';
import type { WorkersEnvType } from 'workers/createHono';

export enum DbEnv {
  LOCAL = 'local',
  DEV = 'dev',
  PRD = 'prd',
}


// Create login schema with email and password
export const EnvOriginSchema = object({
  R2_PUBLIC_URL_PRD: string(),
  R2_PUBLIC_URL_DEV: string(),
  WORKER_URL_LOCAL: string(),
  WORKER_URL_DEV: string(),
  WORKER_URL_PRD: string(),

  SUPABASE_URL: string(),
  SUPABASE_ANON_KEY: string(),
  SUPABASE_SERVICE_ROLE: string(),

  SUPABASE_URL_DEV: string(),
  SUPABASE_ANON_KEY_DEV: string(),
  SUPABASE_SERVICE_ROLE_DEV: string(),

  SUPABASE_URL_LOCAL: string(),
  SUPABASE_ANON_KEY_LOCAL: string(),
  SUPABASE_SERVICE_ROLE_LOCAL: string(),
  OURPR_WEBHOOK_KEY: string(),

  DB_ENV:
    optional(enum_(DbEnv)),
  OURPR_KV: nonOptional(unknown()),
  PUBLIC_BUCKET: nonOptional(unknown()),
  SITE_URL_LOCAL: string(),
  SITE_URL_DEV: string(),
  SITE_URL_PRD: string(),
  STRIPE_KEY_PUBLIC_LOCAL: string(),
  STRIPE_KEY_SECRET_LOCAL: string(),
  STRIPE_KEY_PUBLIC_TEST: string(),
  STRIPE_KEY_SECRET_TEST: string(),
  STRIPE_KEY_PUBLIC_PRD: string(),
  STRIPE_KEY_SECRET_PRD: string(),

  STRIPE_WEBHOOK_SECRET_TEST: string(),
  STRIPE_WEBHOOK_SECRET_DEV: string(),
  STRIPE_WEBHOOK_SECRET_PRD: string(),
});


export const EnvSchema = transform(EnvOriginSchema,
  (input) => {
    return {
      ...input,
      DB_ENV: input.DB_ENV ?? DbEnv.LOCAL,
      SITE_URL: envURL(input, input.DB_ENV).SITE_URL,
      R2_PUBLIC_URL: envURL(input, input.DB_ENV).R2_PUBLIC_URL,
      WORKER_URL: envURL(input, input.DB_ENV).WORKER_URL,
      SB_URL: dbConfig(input, input.DB_ENV).url,
      SB_ANON_KEY: dbConfig(input, input.DB_ENV).anonKey,
      STRIPE_PUBLIC_KEY: stripeKeyEnv(input, input.DB_ENV).STRIPE_PUBLIC_KEY,
      STRIPE_SECRET_KEY: stripeKeyEnv(input, input.DB_ENV).STRIPE_SECRET_KEY,
      STRIPE_WEBHOOK_SECRET: stripeKeyEnv(input, input.DB_ENV).STRIPE_WEBHOOK_SECRET,
    };
  }
)


export const EnvSchemaBrowsor = object({
  DB_ENV:
    enum_(DbEnv),
  SB_URL: string(),
  SB_ANON_KEY: string(),
  R2_PUBLIC_URL: string(),
  WORKER_URL: string(),
  STRIPE_PUBLIC_KEY: string(),
  SITE_URL: string(),
});

export interface Env extends Output<typeof EnvSchema> {
  OURPR_KV: KVNamespace;
  DB_ENV: DbEnv;
  PUBLIC_BUCKET: R2Bucket;
}

//上書き
export interface EnvBrowser extends Output<typeof EnvSchemaBrowsor> {

}

export const environmentWorkers = (env: WorkersEnvType) => {
  try {
    const checkEnv = parse(EnvSchema, env)
    return checkEnv as Env
  } catch (_e) {
    const e = _e as ValiError
    e.issues.forEach((issue) => {
      issue.path?.forEach((path) => {
        console.log('path:', path);
      })
    })
    throw new Error('Environment is not set correctly')
  }
}
export const environment = (context: AppLoadContext) => {
  try {
    const checkEnv = parse(EnvSchema, context.cloudflare.env)
    return checkEnv as Env
  } catch (_e) {
    const e = _e as ValiError
    e.issues.forEach((issue) => {
      issue.path?.forEach((path) => {
        console.log('path:', path);
      })
    })
    throw new Error('Environment is not set correctly')
  }
}
export const environmentBrowsor = () => {
  try {
    const checkEnv = parse(EnvSchemaBrowsor, (window as any).ENV)
    return checkEnv as EnvBrowser
  } catch (_e) {
    const e = _e as ValiError
    console.log('e:', e);
    e.issues.forEach((issue) => {
      issue.path?.forEach((path) => {
        console.log('path:', path);
      })
    })
    throw new Error('Browsor Environment is not set correctly')
  }
}
